import { render } from "./AppNumberNotification.vue?vue&type=template&id=77688a52"
import script from "./AppNumberNotification.vue?vue&type=script&lang=js"
export * from "./AppNumberNotification.vue?vue&type=script&lang=js"

import "./AppNumberNotification.vue?vue&type=style&index=0&id=77688a52&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__